var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"procedure-content"},[_c('section',{staticClass:"body",domProps:{"innerHTML":_vm._s(_vm.procedureContent)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }